import { render, staticRenderFns } from "./handling.vue?vue&type=template&id=ee2ff508&scoped=true&"
import script from "./handling.vue?vue&type=script&lang=js&"
export * from "./handling.vue?vue&type=script&lang=js&"
import style0 from "./handling.vue?vue&type=style&index=0&id=ee2ff508&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2ff508",
  null
  
)

export default component.exports